import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M19.001 0H1A1 1 0 0 0 0 .999V19A1 1 0 0 0 .999 20H19a1 1 0 0 0 .999-.999V1A1 1 0 0 0 19.001 0m-.173 1.172v3.27H1.172v-3.27zM1.172 18.828V5.615h17.656v13.213z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M6.286 11H3.714c-.395 0-.714.258-.714.576v4.848c0 .318.32.576.714.576h2.572c.394 0 .714-.258.714-.576v-4.848c0-.318-.32-.576-.714-.576m-.713 4.847H4.427v-3.694h1.146zM11.286 9H8.714C8.319 9 8 9.263 8 9.587v6.826c0 .324.32.587.714.587h2.572c.395 0 .714-.263.714-.587V9.587c0-.324-.32-.587-.714-.587m-.713 6.826H9.427v-5.652h1.146zM16.286 8h-2.572c-.394 0-.714.262-.714.585v7.83c0 .323.32.585.714.585h2.572c.394 0 .714-.262.714-.585v-7.83c0-.323-.32-.585-.714-.585m-.713 7.83h-1.146V9.17h1.146z"
    }, null, -1)
  ]))]))
}
export default { render: render }